module.exports = __webpack_public_path__ + "static/about_icon_bg-55bde9f5556204a0305cb8b58a01c57d.svg";